import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs/Rx";
import { Message } from "primeng/primeng";
import { UserNavSecurityService,} from "./account/account.service";
import { UserNavigationSecurity } from "./account/model";
@Component({
  moduleId: module.id.toString(),
  template: require('./my-settings.component.html')
})
export class MySettingsComponent implements OnInit {
  busy: Subscription;
  messages: Message[] = [];
  navigationSecurity: UserNavigationSecurity;
  devPortalUrl: string = process.env.AppSettings.devPortalUrl;
  hcmBaseUrl: string = process.env.AppSettings.hcmBaseUrl;
  navigationUrl: string = "/Home/api/Navigation";
  isUserReady: boolean = false;
  isPartnerUser: boolean = false;
  isImpersonated: boolean = false;

  constructor(
    private userNavSecurityService: UserNavSecurityService,) {}

  // Load the security for navigation.
  ngOnInit(): void {
    this.busy = this.userNavSecurityService.getNavigationSecurity().subscribe(
      ns => {
        this.navigationSecurity = ns;
        this.isImpersonated = (ns ? ns.isImpersonated : false);
        this.isUserReady = true;
        this.isPartnerUser = (ns ? ns.isPartnerUser : false);
        if (this.isUserReady && !this.isPartnerUser) {
          try {
            var script = document.createElement('script');
            script.src = this.hcmBaseUrl + '/navigation/globalheader.bundle.js';
            document.body.appendChild(script);
          } catch (e) {
          }
        }
      },
      error => {
        console.log(error);
        // this.messages.push({
        //     severity: 'error',
        //     detail: 'There was a problem retrieving your navigation security settings.',
        //     summary: 'Error!'
        // });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/my-settings.component.ts